import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const actions = createActions(
  {
    EMAIL_LIST_ALL: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    EMAIL_ADD: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    EMAIL_GET: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],

    EMAIL_DELETE: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],

    EMAIL_UPDATE: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],

    EMAIL_GET_FLOWS: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },

  'EMAIL_LIST_ALL_SUCCEEDED',
  'EMAIL_LIST_ALL_FAILED',

  'EMAIL_ADD_SUCCEEDED',
  'EMAIL_ADD_FAILED',

  'EMAIL_UPDATE_SUCCEEDED',
  'EMAIL_UPDATE_FAILED',

  'EMAIL_GET_SUCCEEDED',
  'EMAIL_GET_FAILED',

  'EMAIL_DELETE_SUCCEEDED',
  'EMAIL_DELETE_FAILED',

  'EMAIL_GET_FLOWS_SUCCEEDED',
  'EMAIL_GET_FLOWS_FAILED',
);
